import {
  ClickableTableCell,
  ClickableTableRow,
} from '@/components/Table/ClickableTable'
import { type ColumnId } from '@/features/admin/scope-change-requests/scope-change-request-table-columns'
import { Icon } from '@/components/Icon'
import type { Id } from '@/infra/id'
import { formatDate } from '@/features/admin/scope-change-requests/scope-change-request-formatters'
import styles from './ScopeChangeRequestRow.module.css'

export interface ScopeChangeRequestRowProps {
  columnIds: ColumnId[]
  jobId: Id
  phase: string
  displayStatus: string
  isActive: boolean
  onPress: () => void
  createTime: Date
  jobShortId: string
  workspaceName: string
  jobDisplayName: string
  open: string
}

export function ScopeChangeRequestRow({
  columnIds,
  jobId,
  phase,
  displayStatus,
  isActive,
  onPress,
  createTime,
  jobShortId,
  workspaceName,
  jobDisplayName,
  open,
}: ScopeChangeRequestRowProps) {
  return (
    <ClickableTableRow
      className={styles.root}
      onClick={onPress}
      data-test={`scope-change-requests-list-item-${jobId}-${phase}`}
      active={isActive}
    >
      {columnIds.map((columnId) => {
        switch (columnId) {
          case 'Details':
            return (
              <DetailsCell
                key={columnId}
                createTime={createTime}
                jobShortId={jobShortId}
                workspaceName={workspaceName}
                jobDisplayName={jobDisplayName}
              />
            )
          case 'Open':
            return <TextCell key={columnId}>{open}</TextCell>
          case 'Status':
            return <TextCell key={columnId}>{displayStatus}</TextCell>
          case 'Action':
            return <ArrowCell key={columnId} />
        }
      })}
    </ClickableTableRow>
  )
}

interface DetailsCellProps {
  createTime: Date
  jobShortId: string
  workspaceName: string
  jobDisplayName: string
}

function DetailsCell({
  createTime,
  jobShortId,
  workspaceName,
  jobDisplayName,
}: DetailsCellProps) {
  return (
    <ClickableTableCell>
      <div className={styles.detailsRoot}>
        <div className={styles.detailsMain}>
          <div className={styles.detailsDate}>{formatDate(createTime)}</div>
          <div className={styles.detailsSeparator}>•</div>
          <div className={styles.detailsShortId}>{jobShortId}</div>
        </div>
        <div className={styles.detailsDescription}>
          <div className={styles.jobName}>
            {workspaceName} | {jobDisplayName}
          </div>
        </div>
      </div>
    </ClickableTableCell>
  )
}

interface TextCellProps {
  children: string
}

function TextCell({ children }: TextCellProps) {
  return (
    <ClickableTableCell>
      <div className={styles.text}>{children}</div>
    </ClickableTableCell>
  )
}

function ArrowCell() {
  return (
    <ClickableTableCell>
      <div className={styles.arrow}>
        <Icon name="arrow" size={24} />
      </div>
    </ClickableTableCell>
  )
}
